import {
  ReportingImportNormalizationIssue,
  ReportingImportNormalizationIssueCandidate,
  ReportingImportNormalizationIssueKeys,
} from '../reporting/reporting-import.model';

export enum LoadReportingImportNormalizationIssuesRequestKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
  loadOptions = 'loadOptions',
}

export type ReportingImportNormalizationIssuesLoadOptions = Record<string, unknown>;

export interface LoadReportingImportNormalizationIssuesRequest {
  [LoadReportingImportNormalizationIssuesRequestKeys.runId]?: string | null;
  [LoadReportingImportNormalizationIssuesRequestKeys.uploadActionId]?: string | null;
  [LoadReportingImportNormalizationIssuesRequestKeys.loadOptions]?: ReportingImportNormalizationIssuesLoadOptions | null;
}

export interface ReportingImportNormalizationIssueWithCandidates extends ReportingImportNormalizationIssue {
  candidates: ReportingImportNormalizationIssueCandidate[];
}

export interface LoadReportingImportNormalizationIssuesResponse {
  issues: ReportingImportNormalizationIssueWithCandidates[];
  totalCount?: number;
  unresolvedCount: number;
  resolvedCount: number;
  allResolved: boolean;
}

export function isReportingImportNormalizationIssueResolved(
  issue: ReportingImportNormalizationIssue,
): boolean {
  return issue[ReportingImportNormalizationIssueKeys.isResolved] === true;
}
